import * as React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import { navigate } from 'gatsby';
import { Global } from '@emotion/react';
import './src/styles/fonts';
import { globalStyles } from './src/styles/global';
import {
  setRefreshSession,
  setTokenGetter,
  setUnauthorizedHandler,
} from './src/lib/http-client';
import { useAuthStore } from './src/stores/authStore';

// Wire the API client to the auth store exactly once, at module scope.
// gatsby-browser only runs in the browser, which is the right place for this:
// the client cannot import the store directly without creating a cycle, since
// the store calls the client to log in.
setTokenGetter(() => useAuthStore.getState().accessToken);
setRefreshSession(() => useAuthStore.getState().refreshSession());
setUnauthorizedHandler(() => {
  useAuthStore.getState().clearSession();
  // Guard the redirect: public pages also make API calls, and bouncing an
  // anonymous visitor off the homepage would be worse than the 401 itself.
  if (window.location.pathname.startsWith('/dashboard')) {
    void navigate('/login?error=session_expired');
  }
});

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
  return (
    <>
      <Global styles={globalStyles} />
      {element}
    </>
  );
};
